import React from "react";
import {
  DatePicker as AntDatePicker,
  type DatePickerProps as AntDatePickerProps,
  ConfigProvider,
} from "antd";
import commonStyles from "../../style/components/common.module.scss";
import type { Dayjs } from "dayjs";
import { createPrimaryTheme } from "../../theme/antd-theme";

export type DatePickerTheme = "primary";

interface CustomDatePickerProps {
  label?: string;
  theme?: DatePickerTheme;
  error?: boolean;
  errorMessage?: string;
  onChange?: (date: Dayjs | undefined) => void;
  required?: boolean;
}

interface DatePickerProps
  extends Omit<AntDatePickerProps, "onChange">,
    CustomDatePickerProps {}

const DatePicker: React.FC<DatePickerProps> = ({
  label,
  theme = "primary",
  error = false,
  errorMessage,
  className = "",
  onChange,
  required = false,
  ...props
}) => {
  const themeConfig = createPrimaryTheme();

  const handleChange = (date: Dayjs | null, dateString: string | string[]) => {
    onChange?.(date || undefined);
  };

  return (
    <ConfigProvider theme={themeConfig}>
      <div className={commonStyles.container}>
        {label && (
          <label className={commonStyles.label}>
            {label}{" "}
            {required && (
              <span style={{ color: "var(--color-success)" }}>*</span>
            )}
          </label>
        )}

        <AntDatePicker
          {...props}
          onChange={handleChange}
          status={error ? "error" : undefined}
        />

        {error && errorMessage && (
          <span className={commonStyles.errorMessage}>{errorMessage}</span>
        )}
      </div>
    </ConfigProvider>
  );
};

export default DatePicker;

